document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.block-accordion--item');

  faqItems.forEach((item) => {
    const header = item.querySelector('.block-accordion--header');
    const answer = item.querySelector('.block-accordion--answer');
    const icon = item.querySelector('.block-accordion--icon');

    header.addEventListener('click', () => {
      const isExpanded = header.getAttribute('aria-expanded') === 'true';

      // Close all other items
      faqItems.forEach((otherItem) => {
        if (otherItem !== item) {
          const otherHeader = otherItem.querySelector('.block-accordion--header');
          const otherAnswer = otherItem.querySelector('.block-accordion--answer');
          const otherIcon = otherItem.querySelector('.block-accordion--icon');

          otherHeader.setAttribute('aria-expanded', 'false');
          otherAnswer.hidden = true;
          if (otherIcon) otherIcon.textContent = '+';
        }
      });

      // Toggle current item
      header.setAttribute('aria-expanded', !isExpanded);
      answer.hidden = isExpanded;
      icon.textContent = !isExpanded ? '-' : '+';
    });
  });
});
